export const ConstraintTypes = {
  Relative: "Relative",
  Date: "Date",
  DatePart: "DatePart"
};

export const ConstraintComparison = {
  Before: "Before",
  After: "After",
  Equal: "Equal"
};

export const ConstraintTarget = {
  Start: "Start",
  End: "End"
};

export const ConstraintResolutionOption = {
  MoveSelf: "MoveSelf",
  MoveOther: "MoveOther"
};
